var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "a-drawer",
          {
            staticStyle: {
              height: "100%",
              overflow: "auto",
              "padding-bottom": "53px"
            },
            attrs: {
              title: _vm.title,
              maskClosable: false,
              width: _vm.drawerWidth,
              placement: "right",
              closable: true,
              visible: _vm.visible,
              "z-index": 2
            },
            on: { close: _vm.close }
          },
          [
            _c("template", { slot: "title" }, [
              _c("div", { staticStyle: { width: "100%" } }, [
                _c("span", [_vm._v(_vm._s(_vm.title))]),
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "calc(100% - 51px)",
                      "padding-right": "10px",
                      "text-align": "right"
                    }
                  },
                  [
                    _c("a-button", {
                      staticStyle: {
                        height: "20px",
                        width: "20px",
                        border: "0px"
                      },
                      attrs: { icon: "appstore" },
                      on: { click: _vm.toggleScreen }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c(
              "a-spin",
              { attrs: { spinning: _vm.confirmLoading } },
              [
                _c(
                  "a-form-model",
                  {
                    ref: "form",
                    attrs: { model: _vm.model, rules: _vm.validatorRules }
                  },
                  [
                    _c(
                      "a-form-model-item",
                      {
                        staticStyle: { display: "none" },
                        attrs: {
                          label: _vm.language["user.column.userAccount"],
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                          prop: "username"
                        }
                      },
                      [
                        _c("a-input", {
                          attrs: {
                            placeholder:
                              _vm.language["ad.must"] +
                              _vm.language["user.column.userAccount"],
                            disabled: _vm.disableSubmit
                          },
                          model: {
                            value: _vm.model.username,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "username", $$v)
                            },
                            expression: "model.username"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: _vm.language["user.column.userName"],
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                          prop: "realname"
                        }
                      },
                      [
                        _c("a-input", {
                          attrs: {
                            placeholder:
                              _vm.language["ad.must"] +
                              _vm.language["user.column.userName"],
                            disabled: _vm.disableSubmit
                          },
                          model: {
                            value: _vm.model.realname,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "realname", $$v)
                            },
                            expression: "model.realname"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: _vm.language["column.jobNumber"],
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                          prop: "workNo"
                        }
                      },
                      [
                        _c("a-input", {
                          attrs: {
                            placeholder:
                              _vm.language["portal.front.please.number"],
                            disabled: _vm.disableSubmit
                          },
                          model: {
                            value: _vm.model.workNo,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "workNo", $$v)
                            },
                            expression: "model.workNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: _vm.language["businessGroupName"],
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol
                        }
                      },
                      [
                        _c("a-input", {
                          attrs: {
                            type: "text",
                            placeholder:
                              _vm.language["ad.must"] +
                              " " +
                              _vm.language["businessGroupName"],
                            disabled: _vm.disableSubmit
                          },
                          model: {
                            value: _vm.emp.bg,
                            callback: function($$v) {
                              _vm.$set(_vm.emp, "bg", $$v)
                            },
                            expression: "emp.bg"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: _vm.language["businessUnitName"],
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol
                        }
                      },
                      [
                        _c("a-input", {
                          attrs: {
                            type: "text",
                            placeholder:
                              _vm.language["ad.must"] +
                              " " +
                              _vm.language["businessUnitName"],
                            disabled: _vm.disableSubmit
                          },
                          model: {
                            value: _vm.emp.bu,
                            callback: function($$v) {
                              _vm.$set(_vm.emp, "bu", $$v)
                            },
                            expression: "emp.bu"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: _vm.language["portal.personalOrgCode"],
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol
                        }
                      },
                      [
                        _c("a-input", {
                          attrs: {
                            type: "text",
                            placeholder:
                              _vm.language["ad.must"] +
                              " " +
                              _vm.language["portal.personalOrgCode"],
                            disabled: _vm.disableSubmit
                          },
                          model: {
                            value: _vm.emp.departName,
                            callback: function($$v) {
                              _vm.$set(_vm.emp, "departName", $$v)
                            },
                            expression: "emp.departName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: _vm.language["premission.applicationName"],
                          prop: "selectedApplications",
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol
                        }
                      },
                      [
                        _c("j-multi-select-tag", {
                          attrs: {
                            disabled: _vm.disableSubmit,
                            options: _vm.applicationOptions,
                            placeholder: "请选择应用"
                          },
                          model: {
                            value: _vm.model.selectedApplications,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "selectedApplications", $$v)
                            },
                            expression: "model.selectedApplications"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: _vm.language["column.userType"],
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol
                        }
                      },
                      [
                        _c("JDictSelectTag", {
                          attrs: {
                            type: "radio",
                            disabled: _vm.disableSubmit,
                            dictCode: "protal_user_type"
                          },
                          model: {
                            value: _vm.model.userType,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "userType", $$v)
                            },
                            expression: "model.userType"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.model.userType === "nonemployee"
                      ? _c(
                          "a-form-model-item",
                          {
                            attrs: {
                              label: _vm.language["common.company"],
                              labelCol: _vm.labelCol,
                              wrapperCol: _vm.wrapperCol
                            }
                          },
                          [
                            _c("a-input", {
                              attrs: {
                                placeholder:
                                  _vm.language["common.pleaseInput"] +
                                  _vm.language["common.company"],
                                maxLength: 100,
                                disabled: _vm.disableSubmit
                              },
                              model: {
                                value: _vm.model.companyName,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "companyName", $$v)
                                },
                                expression: "model.companyName"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.departIdShow == true
                      ? _c(
                          "a-form-model-item",
                          {
                            attrs: {
                              label: _vm.language["portal.personalOrgCode"],
                              labelCol: _vm.labelCol,
                              wrapperCol: _vm.wrapperCol
                            }
                          },
                          [
                            _c("j-multi-select-tag", {
                              attrs: {
                                disabled: _vm.disableSubmit,
                                options: _vm.nextDepartOptions
                              },
                              model: {
                                value: _vm.model.departIds,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "departIds", $$v)
                                },
                                expression: "model.departIds"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: _vm.language["column.gender"],
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol
                        }
                      },
                      [
                        _c(
                          "a-select",
                          {
                            attrs: {
                              disabled: _vm.disableSubmit,
                              getPopupContainer: function(target) {
                                return target.parentNode
                              }
                            },
                            model: {
                              value: _vm.model.sex,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sex", $$v)
                              },
                              expression: "model.sex"
                            }
                          },
                          [
                            _c("a-select-option", { attrs: { value: 1 } }, [
                              _vm._v("男")
                            ]),
                            _c("a-select-option", { attrs: { value: 2 } }, [
                              _vm._v("女")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: _vm.language["column.mailbox"],
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                          prop: "email"
                        }
                      },
                      [
                        _c("a-input", {
                          attrs: {
                            placeholder:
                              _vm.language["ad.must"] +
                              _vm.language["column.mailbox"],
                            disabled: _vm.disableSubmit
                          },
                          model: {
                            value: _vm.model.email,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "email", $$v)
                            },
                            expression: "model.email"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: _vm.language["column.cellphoneNumber"],
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                          prop: "phone"
                        }
                      },
                      [
                        _c("a-input", {
                          attrs: {
                            placeholder:
                              _vm.language["ad.must"] +
                              _vm.language["column.cellphoneNumber"],
                            disabled: _vm.disableSubmit
                          },
                          model: {
                            value: _vm.model.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "phone", $$v)
                            },
                            expression: "model.phone"
                          }
                        })
                      ],
                      1
                    ),
                    _c("a-divider", { attrs: { type: "horizontal" } }),
                    _vm.roleLoading
                      ? _c(
                          "a-form-model-item",
                          {
                            attrs: {
                              label: _vm.language["column.userRole"],
                              labelCol: _vm.labelCol,
                              wrapperCol: _vm.wrapperCol,
                              prop: "role"
                            }
                          },
                          [
                            _c("j-select-role-for-apply-check", {
                              attrs: {
                                disabled: _vm.disabledRole,
                                appId: this.appId,
                                option: _vm.rolesOptions
                              },
                              model: {
                                value: _vm.model.role,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "role", $$v)
                                },
                                expression: "model.role"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.roleLoading
                      ? _c(
                          "a-form-model-item",
                          {
                            attrs: {
                              label:
                                _vm.language["user.apply.project.organization"],
                              labelCol: _vm.labelCol,
                              wrapperCol: _vm.wrapperCol
                            }
                          },
                          [
                            _c("a-textarea", {
                              staticStyle: { width: "323px" },
                              attrs: {
                                placeholder:
                                  _vm.language["ad.must"] +
                                  _vm.language[
                                    "user.apply.project.organization"
                                  ],
                                readonly: "readonly"
                              },
                              model: {
                                value: _vm.model.projectDepartNames,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "projectDepartNames", $$v)
                                },
                                expression: "model.projectDepartNames"
                              }
                            }),
                            _c(
                              "a-button",
                              {
                                staticStyle: { "margin-left": "8px" },
                                attrs: { type: "primary", icon: "search" },
                                on: { click: _vm.initDepart }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.language["common.selectButton"])
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.displayAuditRemark
                      ? _c(
                          "a-form-model-item",
                          {
                            attrs: {
                              label: _vm.language["user.apply.review.comments"],
                              labelCol: _vm.labelCol,
                              wrapperCol: _vm.wrapperCol,
                              prop: "phone"
                            }
                          },
                          [
                            _c("a-textarea", {
                              attrs: {
                                placeholder:
                                  _vm.language["ad.must"] +
                                  _vm.language["user.apply.review.comments"],
                                row: "2"
                              },
                              model: {
                                value: _vm.model.auditRemark,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "auditRemark", $$v)
                                },
                                expression: "model.auditRemark"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.auditFlag,
                    expression: "!auditFlag"
                  }
                ],
                staticClass: "drawer-bootom-button"
              },
              [
                _c("a-button", { on: { click: _vm.close } }, [
                  _vm._v(_vm._s(_vm.language["common.cancel"]))
                ]),
                _c(
                  "a-popconfirm",
                  {
                    attrs: {
                      title: _vm.language["common.submitConfirmInfo"],
                      okText: _vm.language["common.submitButton"],
                      cancelText: _vm.language["common.cancel"]
                    },
                    on: { confirm: _vm.goSubmit }
                  },
                  [
                    _c(
                      "a-button",
                      {
                        staticStyle: { margin: "0px 10px" },
                        attrs: { type: "primary" }
                      },
                      [_vm._v(_vm._s(_vm.language["common.submitButton"]))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          2
        )
      ],
      1
    ),
    _c(
      "div",
      [
        _c("j-select-depart-modal-by-singleapplication", {
          ref: "departSelectSingle",
          on: { ok: _vm.ok }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }